export default {
  ignoredArea: {
    pointerEvents: 'none',
  },
};
